import React from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import Form from 'modules/Negoce/components/UploadFiles/Form';

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: column;
  }

  .title {
    font-size: 20px;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #202529;
    text-transform: uppercase;
  }

  .titleContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .fileName {
    opacity: 0.5;
    font-family: ${(props) => props.theme.fonts.sfcompact};
  }

  .ant-btn-secondary:not(:disabled):not(.ant-btn-disabled) {
    background-color: ${(props) => props.theme.colors['terra-cotta']};
    color: ${(props) => props.theme.colors['white']};
    border: none;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    white-space: normal;
  }
`;

const DownloadModels = () => (
  <Card>
    <CardHeader
      styles={`.cardHeader{width:90%}`}
      title={
        <Title>
          <div className="titleContainer">
            <h1 className="title">
              {I18n.t('negoce.submissions.formFiles.title')}
            </h1>
          </div>
        </Title>
      }
      fontSize="20px"
    />
    <Form />
  </Card>
);

export default DownloadModels;
